<template>
    <div class='disclaimer'>
        <b>This is a FAN SITE. It is not affiliated with Toronto Fire Services, or the City of Toronto. In case of Emergency: call 911.</b>
    </div>
</template>

<style scoped>
    .disclaimer {
        font-family: sans-serif;
        font-size: 1em;
        padding-top: 1em;
    }
</style>